import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Default.css";
import { Link } from "react-router-dom";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <div>
          <div
            style={{
              marginLeft: "10px",
              padding: "10px",
              textAlign: "center",
              width: "100%",
              marginLeft: "120px",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                fontWeight: "500",
                opacity: "0.6",
              }}
            >
              Copyright © {new Date().getFullYear()} by SmarterHomes Private
              Ltd. All Rights Reserved. {process.env.REACT_APP_VERSION}
            </span>
            <div
              style={{
                marginTop: "5px",
                // display: "flex",
                gap: "8px",
                color: "#707070",
                fontSize: "11px",
                flexWrap: "wrap",
                textAlign: "center",
              }}
            >
              <Link
                to="/termsandconditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </Link>{" "}
              |{"  "}
              <Link
                to="/privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </Link>{" "}
              |{"  "}
              <Link
                to="/refundpolicy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Refund Policy
              </Link>{" "}
              |{"  "}
              <Link to="/contactus" target="_blank" rel="noopener noreferrer">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
